import { useRef, useEffect } from 'react';
import { ga } from '@/lib/analytics';

export const useGAMouseInteraction = (sectionName: string) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const isMouseOverRef = useRef<boolean>(false);

  const sendGAEvent = (dwellTimeMs: number) => {
    ga.trackSectionInteraction({
      section: sectionName,
      dwell_time_ms: dwellTimeMs,
    });
  };

  const handleMouseEnter = () => {
    isMouseOverRef.current = true;

    timerRef.current = setTimeout(() => {
      if (isMouseOverRef.current) {
        sendGAEvent(1000);
      }
    }, 1000);

    intervalRef.current = setInterval(() => {
      if (isMouseOverRef.current) {
        sendGAEvent(10000);
      }
    }, 10000);
  };

  const handleMouseLeave = () => {
    isMouseOverRef.current = false;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    return () => {
      isMouseOverRef.current = false;

      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  return {
    handleMouseEnter,
    handleMouseLeave,
  };
};
